const findAddressComponent = (components = [], ...types) => components.find(
  (component) => types.some((type) => component.types.includes(type)),
);

const parsePlaceAddress = (place = {}) => {
  const components = place.address_components || [];
  const postalCode = findAddressComponent(components, 'postal_code')?.long_name;
  const zipSuffix = findAddressComponent(components, 'postal_code_suffix')?.long_name;

  return {
    address1: place.name,
    city: findAddressComponent(
      components,
      'locality',
      'postal_town',
      'sublocality_level_1',
      'administrative_area_level_3',
    )?.long_name,
    state: findAddressComponent(components, 'administrative_area_level_1')?.long_name,
    stateCode: findAddressComponent(components, 'administrative_area_level_1')?.short_name,
    zip: zipSuffix ? `${postalCode}-${zipSuffix}` : postalCode,
  };
};

export default parsePlaceAddress;
